import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { STATO_TICKET } from "../model/statoTicket";

export default function useTicketConfigTable() {
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "";
    const date = parseISO(dateTimeString);
    return format(date, "d MMMM yyyy 'alle' HH:mm", { locale: it });
  };

  return [
    {
      label: "Creato da",
      key: "utente",
      hideOrder: true,
      formatter: (value, rowData) => {
        const nome = value?.nome || "";
        const cognome = value?.cognome || "";
        const dataInserimento = rowData?.data_inserimento || "";
        return `${nome} ${cognome} il ${formatDateTime(dataInserimento)}`;
      },
    },
    {
      label: "Corso",
      key: "classe",
      hideOrder: true,
      formatter: (value) => `${value.denominazione} - ${value.denominazione_corso}`,
    },
    { label: "Oggetto", key: "oggetto" },
    {
      label: "Ultimo messaggio",
      key: "data_ultimo_messaggio",
      hideOrder: true,
      formatter: (value, rowData) => {
        if (!value || !rowData.utente_ultimo_messaggio) {
          return "Nessun messaggio";
        }
        const nome = rowData.utente_ultimo_messaggio?.nome || "";
        const cognome = rowData.utente_ultimo_messaggio?.cognome || "";
        return `${nome} ${cognome} il ${formatDateTime(value)}`;
      },
    },
    {
      label: "Stato",
      key: "stato",
      formatter: (value) => {
        if (value === STATO_TICKET.APERTO) {
          return (
            <>
              Aperto <i className="bi bi-circle-fill text-success"></i>
            </>
          );
        } else {
          return (
            <>
              Chiuso <i className="bi bi-circle-fill text-danger"></i>
            </>
          );
        }
      },
    },
  ];
}
